// Stripe Elements appearance config for the donation form. Extracted
// VERBATIM (pure static data) from DonationForm's render.
const stripeAppearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#B89569',
    colorText: '#171717',
    colorTextSecondary: '#6B7280',
    colorTextPlaceholder: '#9CA3AF',
    colorBackground: '#ffffff',
    colorDanger: '#DC2626',
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    borderRadius: '8px',
    fontSizeBase: '13px',
    spacingUnit: '4px'
  },
  rules: {
    '.Input': {
      borderRadius: '8px',
      border: '0.5px solid #D4B48A',
      color: '#171717',
      padding: '0.875rem 1rem',
      fontSize: '13px'
    },
    '.Input:focus': {
      borderColor: '#B89569',
      boxShadow: '0 0 0 2px #F5EFE6'
    },
    '.Tab': {
      borderRadius: '8px',
      border: '0.5px solid #D4B48A',
      color: '#171717'
    },
    '.Tab:hover': {
      borderColor: '#B89569',
      backgroundColor: '#F5EFE6'
    },
    '.Tab--selected': {
      borderColor: '#B89569',
      backgroundColor: '#F5EFE6',
      color: '#7A5E3A'
    },
    '.Tab:focus': {
      boxShadow: '0 0 0 2px #F5EFE6'
    },
    '.Block': {
      borderRadius: '8px',
      border: '0.5px solid #D4B48A'
    },
    '.Label': {
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: '0.025em',
      color: '#171717',
      fontSize: '13px'
    },
    '.TabIcon': { color: '#7A5E3A' },
    '.TabLabel': { color: '#171717' },
    '.Text': { color: '#171717' },
    '.Link': { color: '#B89569' }
  }
};

export default stripeAppearance;
